import { NgFor, NgIf } from "@angular/common";
import { HorizontalTextInputComponent } from "../../../../../../assist/src/app/_shared/form/components/horizontal-text-input/horizontal-text-input.component";
import { ButtonComponent } from "../../../../../../assist/src/app/_shared/form/components/button/button.component";
import { RadioComponent } from "../../../../../../assist/src/app/_shared/form/components/radio/radio.component";
import { Component, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { BasePage } from "../../../../../../assist/src/app/_shared/components/layout/pages/base-page";
import { AssistAuthService } from "../../../auth/assist-auth.service";
import { OrganizationService } from "../../../organization/services/oranization.service";
import { UserPersonService } from "../../services/user-person.service";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UserPersonListDto } from "../../models/user-person";
import { MatchablePersonDto } from "../../models/coupling";
import { OrganizationPublicAccessKeyDto } from "../../../../../../assist/src/app/organisation/models/organization";

interface MatchCandidate {
  person: MatchablePersonDto;
  control: FormControl;
}

@Component({
  selector: 'app-person-modal',
  templateUrl: './person-modal.component.html',
  styleUrls: ['./person-modal.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    HorizontalTextInputComponent,
    ButtonComponent,
    RadioComponent,
    NgFor,
  ],
})
export class PersonModalComponent extends BasePage implements OnInit {

  organization: OrganizationPublicAccessKeyDto = {} as OrganizationPublicAccessKeyDto;
  persons: UserPersonListDto[] = [];

  // Kandidaten met hetzelfde e-mailadres, ter selectie getoond wanneer de gebruiker nog niets gekoppeld heeft.
  matchCandidates: MatchCandidate[] = [];
  showSelection = false;
  isCoupling = false;

  constructor(
    protected override route: ActivatedRoute,
    protected override modal: NgbModal,
    protected router: Router,
    public auth: AssistAuthService,
    protected userPersonService: UserPersonService,
    protected organizationService: OrganizationService,
    protected activeModal: NgbActiveModal,
  ) {
    super(route, modal);
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.organizationService.getAccessKey().subscribe((o) => {
      this.organization = o;
      this.loadPersons(true);
    });
  }

  // allowMatchableLookup: enkel bij de eerste lading tonen we de e-mailmatch-selectie. Na het koppelen
  // herladen we met false, zodat de standaardflow (1 persoon tonen / keuze bij meerdere) overneemt.
  private loadPersons(allowMatchableLookup: boolean): void {
    this.userPersonService
      .getAll('?organizationKey=' + this.organization.accessKey)
      .subscribe((persons) => {
        if (persons.length === 0 && allowMatchableLookup) {
          this.loadMatchCandidates();
        } else {
          this.setPersons(persons);
        }
      });
  }

  // Haalt de personen met hetzelfde geverifieerde e-mailadres op en toont ze ter selectie
  // (standaard allemaal aangevinkt). Bij een fout of geen kandidaten valt de modal terug op de
  // bestaande "geen personen gekoppeld"-melding.
  private loadMatchCandidates(): void {
    this.userPersonService.getMatchableByEmail(this.organization.accessKey).subscribe({
      next: (candidates) => {
        this.matchCandidates = candidates.map((person) => ({
          person,
          control: new FormControl(true),
        }));
        this.showSelection = candidates.length > 0;
        this.isLoading = false;
      },
      error: () => {
        this.showSelection = false;
        this.isLoading = false;
      },
    });
  }

  get hasSelection(): boolean {
    return this.matchCandidates.some((c) => !!c.control.value);
  }

  couple(): void {
    const selectedIds = this.matchCandidates
      .filter((c) => !!c.control.value)
      .map((c) => c.person.personId);
    if (selectedIds.length === 0) {
      return;
    }
    this.isCoupling = true;
    this.userPersonService.coupleByEmail(this.organization.accessKey, selectedIds).subscribe({
      next: () => {
        this.isCoupling = false;
        this.showSelection = false;
        this.matchCandidates = [];
        this.isLoading = true;
        this.loadPersons(false);
      },
      error: () => {
        this.isCoupling = false;
      },
    });
  }

  private setPersons(persons: UserPersonListDto[]): void {
    this.persons = persons;
    this.showSelection = false;
    this.isLoading = false;

    if (this.persons.length === 1) {
      const person = this.persons[0];
      this.router.navigate(['/NL/', this.organization.accessKey, 'person', person.person.accessKey, 'edit']).then(() => {
        this.close();
      });
    }
  }

  close() {
    this.activeModal.close();
  }

  loginAs(p: UserPersonListDto) {
    this.router.navigate(['/NL/', this.organization.accessKey, 'person', p.person.accessKey, 'edit']).then(() => {
      this.close()
    });
  }

}
